import React from 'react';
import { Typography, Alert } from '@one-thd/sui-atomic-components';

const ReturnSummaryAlert = () => {
  return (
    <div className="sui-mb-8">
      <Alert status="success" size="small">
        <Typography variant="body-base">Return request submitted</Typography>
      </Alert>
    </div>
  );
};

export default ReturnSummaryAlert;
